import { RangeFilter } from '../../../shared/models/range.model';

import { Serializable } from '../../../core/models/serializable';

export class SystemConfigurationFilterModel
  implements Serializable<SystemConfigurationFilterModel>
{
  fromObject(obj: any): SystemConfigurationFilterModel {
    throw new Error('Not Implemented');
  }
  toObject() {
    let result = {
      SettingId: this.settingId,
      KeyName: this.keyName,
      Name: this.name,
      Description: this.description,
      Level: this.level,
      Value: this.value,
    };
    return result;
  }

  public settingId: number;
  public keyName: string;
  public name: string;
  public description: string;
  public level: string;
  public value: number;

  constructor() {
    this.settingId = null;
    this.keyName = null;
    this.name = null;
    this.description = null;
    this.level = null;
    this.value = null;
  }
}
